// extracted by mini-css-extract-plugin
export default {"battery":"styles_battery__fq9++"};